import React, {Component} from 'react';
import {plainTranslate} from '../../common/translate.jsx';
import { connect } from 'react-redux';
import SettingsMenu from '../../sidebar/settings-menu.jsx';
import Stages from '../stages.jsx';
import { fetchSettings} from "../../../actions/actions.jsx";
import { Skeleton } from 'antd';

class Settings extends Component {

    constructor(props) {
        super(props);  
        this.state = {
            showMessage: false,
            ready: false
        }; 
        this.allSettings = [
            { value: "", name: '', text: ''},
        ];
        
        this.updateStages = this.updateStages.bind(this);
    }
    
    componentDidMount() {
        this.props.getSettings('/' + this.props.match.params.db + '/api/contract/settings/contract-settings', 'contractSettings')
        .then(res => {            
            this.setState({ready: true})
        })
         if (this.props.title) {
            let titleArr = this.props.title;
            titleArr.map((item, key) => titleArr[key] = plainTranslate(this.props.settings.locale, item));
            document.title = titleArr.join(' ');
        }
        
    } 
    
    updateStages() {
        this.props.getSettings('/' + this.props.match.params.db + '/api/contract/settings/contract-settings', 'contractSettings');
    }
    
    render() {

        return (
                <div>
                    <SettingsMenu 
                       location = {this.props.location.pathname} db = {this.props.match.params.db}/>
                    <form name="settings_contract" className="cmxform form-horizontal bucket-form ng-pristine ng-valid">
                       <div className="row m-bot15">
                          <div className="col-lg-12">
                             <section className="panel">
                                <div className="panel-body">
                                   <div className="settings">
                                        <div className="col-sm-12 column-centered">
                                            {this.state.ready ?
                                            <Stages
                                                saveRoute={'/' + this.props.match.params.db + '/api/stages/save/settings/data'}
                                                type={'contractSettings'}
                                                workflow={"contract"}
                                                configuration = {false}
                                                value={this.props.settings.contractSettings}
                                                settings={this.props.settings}
                                                fields={this.allSettings}
                                                setting = {'stages'}
                                                roles={'roles'}
                                                updateStages={this.updateStages}
                                            />
                                            :
                                            <Skeleton active />}
                                        </div>
                                   </div> 
                                </div>
                             </section>
                          </div>
                       </div>    
                    </form>        
                </div>
                );
    }
}

const mapStateToProps = state => ({
        settings: state.settings,
    });

const mapDispatchToProps = dispatch => ({
   getSettings: (path, type) =>
            dispatch(fetchSettings(path, type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);


